var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgUmbrella(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 18.089,
    height: 18.029,
    viewBox: "0 0 18.089 18.029",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Cobertura",
    transform: "translate(-1.9 -2)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trazado_7720",
    "data-name": "Trazado 7720",
    d: "M31.37,2a.269.269,0,0,0-.27.27V3.683h.571V2.27a.32.32,0,0,0-.3-.27",
    transform: "translate(-20.426)",
    fill: "#3e4347"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_7721",
    "data-name": "Trazado 7721",
    d: "M31.1,24.5h.571v7.332H31.1Z",
    transform: "translate(-20.426 -15.739)",
    fill: "#b8c2c4"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_7722",
    "data-name": "Trazado 7722",
    d: "M32,6.7v7.332a2.9,2.9,0,0,1,2.314-1.142,2.948,2.948,0,0,1,2.314,1.142C36.177,9.885,34.314,6.7,32,6.7Z",
    transform: "translate(-21.056 -3.288)",
    fill: "#ffbe5c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_7723",
    "data-name": "Trazado 7723",
    d: "M21.227,6.7v7.332a2.915,2.915,0,0,0-4.627,0C17.051,9.885,18.914,6.7,21.227,6.7Z",
    transform: "translate(-10.283 -3.288)",
    fill: "#ed77a8"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_7724",
    "data-name": "Trazado 7724",
    d: "M32,6.7c2.314,0,4.177,3.185,4.627,7.332a2.9,2.9,0,0,1,2.314-1.142,2.977,2.977,0,0,1,2.1.871A9.247,9.247,0,0,0,32,6.7Z",
    transform: "translate(-21.056 -3.288)",
    fill: "#c7e86f"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_7725",
    "data-name": "Trazado 7725",
    d: "M10.944,6.7c-2.314,0-4.177,3.185-4.627,7.332A2.9,2.9,0,0,0,4,12.89a2.977,2.977,0,0,0-2.1.871A9.247,9.247,0,0,1,10.944,6.7",
    transform: "translate(0 -3.288)",
    fill: "#60d4e0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_7726",
    "data-name": "Trazado 7726",
    d: "M22.125,48.9v1.683a1.142,1.142,0,0,1-2.284,0,.571.571,0,0,0-.571-.571.553.553,0,0,0-.571.571,2.254,2.254,0,1,0,4.507,0V48.9H22.125",
    transform: "translate(-11.752 -32.808)",
    fill: "#3e4347"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUmbrella);
export default __webpack_public_path__ + "static/media/umbrella.be5454e18c21e66475eec8c8f62a01b8.svg";
export { ForwardRef as ReactComponent };